// What can be bought, what it grants, and the fair-use limits. Prices here are for display;
// Stripe holds the real prices (STRIPE_PRICE_* env), and is the merchant of record.

export type ProductId = 'santa' | 'elf' | 'bundle';

export const PRODUCTS: Record<ProductId, { santa: number; elf: number; cents: number; price: string; name: string; blurb: string }> = {
  santa: { santa: 1, elf: 0, cents: 699, price: '€6.99', name: 'Santa call', blurb: 'One 6-minute live call with Santa in his cabin, with Mrs. Claus answering.' },
  elf: { santa: 0, elf: 7, cents: 499, price: '€4.99', name: 'Elf Pass', blurb: '7 four-minute calls with Pipa the elf: the Nice List, a daily sparkle mission and workshop news. One a day.' },
  bundle: { santa: 1, elf: 7, cents: 999, price: '€9.99', name: 'Family bundle', blurb: 'The Santa call and the Elf Pass together.' },
};

export const LIMITS = {
  santaPerDay: 3,
  elfPerDay: 1,
  previewsPerDay: 3,
  refundsPerDay: 2, // calls that fail in the first seconds give the credit back, this many a day
  refundUnderSeconds: 20,
};

/** What we reserve against the daily budget when a call starts (replaced by the real cost after). */
export const RESERVE_USD = { santa: 0.6, elf: 0.3, 'preview-santa': 0.01, 'preview-elf': 0.01 } as const;

/** Gemini 3.8 Live, paid tier, USD per 1M tokens. */
export const LIVE_PRICE = { inText: 0.75, inAudio: 3, outText: 4.5, outAudio: 12 };
